/* ADD GROUPS */
export const ADD_QUESTION = "ADD_QUESTION"
export const ADD_QUESTION_SUCCESS = "ADD_QUESTION_SUCCESS"
export const ADD_QUESTION_CLEAN = "ADD_QUESTION_CLEAN"
export const ADD_QUESTION_ERROR = "ADD_QUESTION_ERROR"
